<template lang='pug'>
  #GPT.main-page.GPT-color.page-noScroll.pb-0.position-relative
    v-row#page-head.d-flex.align-center.justify-md-space-between
      v-col.d-flex.align-center.px-0.pb-0.px-md-3.pb-md-4(cols='12')
        h1.my-0(style="font-weight: 700; font-size: 28px; font-family: 'Segoe UI'; white-space: nowrap;") {{$t('LOGIN_PAGE_SETTING.TITLE')}}
    #page-inner.scroll-x.pb-0.height_100vh
      .upload_page_height.scrollbar.px-3()
        v-container()
          v-card.rounded-card(style='padding:20px 0px 35px 0px;').scrollbar.pl-md-10.pr-md-10.pl-3.pr-3
            v-row.justify-md-space-between
              v-col(cols='12')
                span(style="color:#444; font-weight:600; font-size:20px;") {{$t('LOGIN_PAGE_SETTING.SECTION_TITLE')}}
              //- 左欄：圖片上傳
              v-col(cols='12' md='5')
                //- 公司 Logo
                .lps-field
                  label.lps-label-16 {{$t('LOGIN_PAGE_SETTING.LOGO_IMAGE')}}
                  .lps-img-box.lps-img-box--logo(@click="triggerLogoUpload")
                    img.lps-img-preview--contain(v-if="form.logo_image_url" :src="form.logo_image_url")
                    .lps-img-box__empty(v-else)
                      img.lps-img-preview--contain(:src="require('@/assets/images/UPGPT.png')" alt="UPGPT")
                    .lps-img-box__overlay
                      v-icon(color="white" size="28") mdi-camera
                    v-btn.lps-img-box__delete(v-if="form.logo_image_url" icon x-small @click.stop="removeLogo")
                      v-icon(color="#444" size="14") icon-remove
                  input(type="file" ref="logoInput" style="display:none" accept="image/png" @change="onLogoChange")
                  span.lps-hint {{$t('LOGIN_PAGE_SETTING.LOGO_HINT')}}

                //- 背景圖片
                .lps-field
                  label.lps-label-16 {{$t('LOGIN_PAGE_SETTING.BG_IMAGE')}}
                  .lps-img-box.lps-img-box--bg(@click="triggerBgUpload")
                    img.lps-img-preview--cover(v-if="form.bg_image_url" :src="form.bg_image_url")
                    .lps-img-box__empty(v-else)
                      img.lps-img-preview--cover(:src="require('@/assets/images/bg-upgpt-login.jpg')" alt="background")
                    .lps-img-box__overlay
                      v-icon(color="white" size="28") mdi-camera
                    v-btn.lps-img-box__delete(v-if="form.bg_image_url" icon x-small @click.stop="removeBg")
                      v-icon(color="#444" size="14") icon-remove
                  input(type="file" ref="bgInput" style="display:none" accept="image/jpeg,image/jpg" @change="onBgChange")
                  span.lps-hint {{$t('LOGIN_PAGE_SETTING.BG_HINT')}}

              //- 右欄：設定欄位
              v-col(cols='12' md='7')
                .div.pb-2
                  label.lps-label {{$t('LOGIN_PAGE_SETTING.LOGIN_URL_LABEL')}}
                //- UpGPT Portal URL
                .lps-field
                  label.lps-label {{$t('LOGIN_PAGE_SETTING.PORTAL_URL_LABEL')}}
                  .d-flex.align-center
                    v-text-field.login-setting-input(
                      :value="portalUrl"
                      readonly dense hide-details
                      style="font-size:14px;"
                    )
                      template(v-slot:append)
                        v-btn(icon small :title="$t('LOGIN_PAGE_SETTING.COPY')" @click="copyPortalUrl")
                          v-icon(color="#808080" size="18") mdi-content-copy
                //- UPGPT Console URL
                .lps-field
                  label.lps-label {{$t('LOGIN_PAGE_SETTING.CONSOLE_URL_LABEL')}}
                  .d-flex.align-center
                    v-text-field.login-setting-input(
                      :value="loginUrl"
                      readonly dense hide-details
                      style="font-size:14px;"
                    )
                      template(v-slot:append)
                        v-btn(icon small :title="$t('LOGIN_PAGE_SETTING.COPY')" @click="copyUrl")
                          v-icon(color="#808080" size="18") mdi-content-copy
                  //span.lps-hint {{$t('LOGIN_PAGE_SETTING.LOGIN_URL_DESC')}}

                //- 標題文字
                .lps-field
                  label.lps-label {{$t('LOGIN_PAGE_SETTING.TITLE_TEXT')}}
                  v-text-field.login-setting-input(
                    v-model="form.title_text"
                    dense hide-details
                    :placeholder="$t('LOGIN_PAGE_SETTING.TITLE_TEXT_PLACEHOLDER')"
                    :maxlength="TITLE_MAX"
                    style="font-size:14px;"
                  )
                  span.lps-hint {{$t('LOGIN_PAGE_SETTING.TITLE_TEXT_HINT')}}

                //- 標題顏色
                .lps-field
                  label.lps-label {{$t('LOGIN_PAGE_SETTING.TITLE_COLOR')}}
                  v-menu(:close-on-content-click="false" offset-y)
                    template(v-slot:activator="{ on, attrs }")
                      .lps-color-swatch(v-bind="attrs" v-on="on")
                        span.lps-color-swatch__block(:style="colorBlockStyle(form.title_color)")
                        span.lps-color-swatch__hex {{form.title_color || $t('LOGIN_PAGE_SETTING.COLOR_UNSET')}}
                    v-card
                      v-color-picker(
                        :value="form.title_color || '#000000'"
                        hide-mode-switch flat width="280"
                        @input="onColorInput('title_color', $event)"
                      )
                  v-divider.my-0
                //- 副標文字
                .lps-field
                  label.lps-label {{$t('LOGIN_PAGE_SETTING.SUBTITLE_TEXT')}}
                  v-textarea.login-setting-input.hide-arrow(
                    v-model="form.subtitle_text"
                    dense hide-details no-resize
                    :placeholder="$t('LOGIN_PAGE_SETTING.SUBTITLE_TEXT_PLACEHOLDER')"
                    :maxlength="SUBTITLE_MAX"
                    rows="1"
                    style="font-size:14px;"
                  )
                  span.lps-hint {{$t('LOGIN_PAGE_SETTING.SUBTITLE_TEXT_HINT')}}
                  //- span.lps-hint {{$t('LOGIN_PAGE_SETTING.SUBTITLE_TEXT_HINT')}} ({{form.subtitle_text.length}}/{{SUBTITLE_MAX}})

                //- 副標顏色
                .lps-field
                  label.lps-label {{$t('LOGIN_PAGE_SETTING.SUBTITLE_COLOR')}}
                  v-menu(:close-on-content-click="false" offset-y)
                    template(v-slot:activator="{ on, attrs }")
                      .lps-color-swatch(v-bind="attrs" v-on="on")
                        span.lps-color-swatch__block(:style="colorBlockStyle(form.subtitle_color)")
                        span.lps-color-swatch__hex {{form.subtitle_color || $t('LOGIN_PAGE_SETTING.COLOR_UNSET')}}
                    v-card
                      v-color-picker(
                        :value="form.subtitle_color || '#1095AF'"
                        hide-mode-switch flat width="280"
                        @input="onColorInput('subtitle_color', $event)"
                      )
                  v-divider.my-0

                //- 登入按鈕
                .lps-section-header {{$t('LOGIN_PAGE_SETTING.LOGIN_BUTTON')}}

                //- 按鈕顏色
                .lps-field
                  label.lps-label {{$t('LOGIN_PAGE_SETTING.BUTTON_COLOR')}}
                  v-menu(:close-on-content-click="false" offset-y)
                    template(v-slot:activator="{ on, attrs }")
                      .lps-color-swatch(v-bind="attrs" v-on="on")
                        span.lps-color-swatch__block(:style="colorBlockStyle(form.button_color)")
                        span.lps-color-swatch__hex {{form.button_color || $t('LOGIN_PAGE_SETTING.COLOR_UNSET')}}
                    v-card
                      v-color-picker(
                        :value="form.button_color || '#14C6DE'"
                        hide-mode-switch flat width="280"
                        @input="onColorInput('button_color', $event)"
                      )
                  v-divider.my-0

                //- 文字顏色
                .lps-field
                  label.lps-label {{$t('LOGIN_PAGE_SETTING.BUTTON_TEXT_COLOR')}}
                  v-menu(:close-on-content-click="false" offset-y)
                    template(v-slot:activator="{ on, attrs }")
                      .lps-color-swatch(v-bind="attrs" v-on="on")
                        span.lps-color-swatch__block(:style="colorBlockStyle(form.button_text_color)")
                        span.lps-color-swatch__hex {{form.button_text_color || $t('LOGIN_PAGE_SETTING.COLOR_UNSET')}}
                    v-card
                      v-color-picker(
                        :value="form.button_text_color || '#FFFFFF'"
                        hide-mode-switch flat width="280"
                        @input="onColorInput('button_text_color', $event)"
                      )
                  v-divider.my-0  
                    
                //- 確認按鈕
                .d-flex.justify-end.mt-6
                  v-btn.lps-confirm-btn(@click="save" :loading="saving" depressed :ripple="false" )
                    span.px-12 {{$t('LOGIN_PAGE_SETTING.SAVE')}}

    v-dialog(v-model='successDialog' width='360' content-class='statusDialog' @keydown.enter='onEmitSuccessDialog(true)')
      success-dialog(@emitSuccessDialog='onEmitSuccessDialog')
    v-dialog(v-model='errorDialog' width='360' content-class='statusDialog' @keydown.esc='onEmitErrorDialog(false)' @keydown.enter='onEmitErrorDialog(true)')
      error-dialog(@emitErrorDialog='onEmitErrorDialog' :errorMessage='errorMessage')
</template>

<script>
import successDialog from "@/components/Dialog/successDialog";
import errorDialog from "@/components/Dialog/errorDialog";
import i18n from '/common/plugins/vue-i18n.js';
import PreferenceService from '@/services/PreferenceService';

const TITLE_MAX = 20;
const SUBTITLE_MAX = 50;
const MAX_FILE_SIZE = 5242880; // 5MB

export default {
  name: 'LoginPageSetting',
  components: { successDialog, errorDialog },
  data() {
    return {
      TITLE_MAX,
      SUBTITLE_MAX,
      form: {
        logo_image: null,
        logo_image_url: '',
        bg_image: null,
        bg_image_url: '',
        title_text: '',
        subtitle_text: '',
        title_color: '#044958',
        subtitle_color: '#1095AF',
        button_color: '#14C6DE',
        button_text_color: '#FFFFFF',
      },
      saving: false,
      isSSO: false,
      loginUrl: '',
      successDialog: false,
      errorDialog: false,
      errorMessage: '',
    };
  },
  computed: {
    portalUrl() {
      return this.loginUrl ? `${this.loginUrl}&next=%2Fupgpt_portal%2F` : '';
    },
  },
  watch: {
    'form.title_color'(val) { if (val && typeof val === 'object') this.form.title_color = val.hex || ''; },
    'form.subtitle_color'(val) { if (val && typeof val === 'object') this.form.subtitle_color = val.hex || ''; },
    'form.button_color'(val) { if (val && typeof val === 'object') this.form.button_color = val.hex || ''; },
    'form.button_text_color'(val) { if (val && typeof val === 'object') this.form.button_text_color = val.hex || ''; },
  },
  async created() {
    const tenant = window.localStorage.getItem('tenant') || '';
    try {
      const authRes = await PreferenceService.isADFSLogin();
      this.isSSO = authRes.data === 'ADFS';
    } catch (e) {
      this.isSSO = false;
    }
    this.loginUrl = this.isSSO
      ? `${window.location.origin}/sso-upgpt-login?tenant=${tenant}`
      : `${window.location.origin}/upgpt-login?tenant=${tenant}`;
    await this.loadSettings();
  },
  methods: {
    // ── 圖片上傳 ──────────────────────────────────
    triggerLogoUpload() {
      this.$refs.logoInput.click();
    },
    triggerBgUpload() {
      this.$refs.bgInput.click();
    },
    onLogoChange(e) {
      const file = e.target.files[0];
      e.target.value = '';
      if (!file) return;
      if (!['image/png'].includes(file.type)) {
        this.showErrorDialog(i18n.t('LOGIN_PAGE_SETTING.IMG_FORMAT_ERROR_LOGO'));
        return;
      }
      if (file.size > MAX_FILE_SIZE) {
        this.showErrorDialog(i18n.t('LOGIN_PAGE_SETTING.IMG_SIZE_ERROR'));
        return;
      }
      this.form.logo_image = file;
      this.form.logo_image_url = URL.createObjectURL(file);
    },
    onBgChange(e) {
      const file = e.target.files[0];
      e.target.value = '';
      if (!file) return;
      if (!['image/jpeg', 'image/jpg'].includes(file.type)) {
        this.showErrorDialog(i18n.t('LOGIN_PAGE_SETTING.IMG_FORMAT_ERROR_BG'));
        return;
      }
      if (file.size > MAX_FILE_SIZE) {
        this.showErrorDialog(i18n.t('LOGIN_PAGE_SETTING.IMG_SIZE_ERROR'));
        return;
      }
      this.form.bg_image = file;
      this.form.bg_image_url = URL.createObjectURL(file);
    },
    removeLogo() {
      this.form.logo_image = null;
      this.form.logo_image_url = '';
    },
    removeBg() {
      this.form.bg_image = null;
      this.form.bg_image_url = '';
    },
    // ── 顏色選擇器 ──────────────────────────────────
    onColorInput(field, val) {
      let hex = typeof val === 'string' ? val : (val && val.hex) ? val.hex : '';
      if (hex.length > 7) hex = hex.slice(0, 7);
      this.form[field] = hex.toUpperCase();
    },
    colorBlockStyle(color) {
      const needBorder = !color || color.toUpperCase() === '#FFFFFF';
      return {
        backgroundColor: color || '#BEBEBE',
        border: needBorder ? '1px solid #BEBEBE' : 'none',
      };
    },
    // ── 複製 URL ──────────────────────────────────
    copyUrl() {
      if (!this.loginUrl) return;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.loginUrl);
      } else {
        const el = document.createElement('textarea');
        el.value = this.loginUrl;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
      }
    },
    copyPortalUrl() {
      if (!this.portalUrl) return;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.portalUrl);
      } else {
        const el = document.createElement('textarea');
        el.value = this.portalUrl;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
      }
    },
    // ── 載入設定 ──────────────────────────────────
    async loadSettings() {
      try {
        const res = await PreferenceService.getLoginPageSetting();
        const val = res.data;
        if (val && typeof val === 'object' && !Array.isArray(val)) {
          this.form.logo_image_url = val.logo_image_url || '';
          this.form.bg_image_url = val.bg_image_url || '';
          this.form.title_text = val.title_text || '';
          this.form.subtitle_text = val.subtitle_text || '';
          this.form.title_color = val.title_color || this.form.title_color;
          this.form.subtitle_color = val.subtitle_color || this.form.subtitle_color;
          this.form.button_color = val.button_color || this.form.button_color;
          this.form.button_text_color = val.button_text_color || this.form.button_text_color;
        }
      } catch (e) {
        // 載入失敗不影響頁面顯示，保留空白表單
      }
    },
    // ── 儲存 ──────────────────────────────────────
    async save() {
      this.saving = true;
      try {
        const formData = new FormData();
        if (this.form.logo_image) formData.append('logo_image', this.form.logo_image);
        formData.append('logo_image_url', this.form.logo_image_url || '');
        if (this.form.bg_image) formData.append('bg_image', this.form.bg_image);
        formData.append('bg_image_url', this.form.bg_image_url || '');
        formData.append('title_text', this.form.title_text || '');
        formData.append('subtitle_text', this.form.subtitle_text || '');
        formData.append('title_color', this.form.title_color || '');
        formData.append('subtitle_color', this.form.subtitle_color || '');
        formData.append('button_color', this.form.button_color || '');
        formData.append('button_text_color', this.form.button_text_color || '');

        const res = await PreferenceService.saveLoginPageSetting(formData);
        const saved = res.data;
        // 儲存後清除暫存檔案物件，以 server 回傳的 URL 為準
        this.form.logo_image = null;
        this.form.logo_image_url = saved.logo_image_url || '';
        this.form.bg_image = null;
        this.form.bg_image_url = saved.bg_image_url || '';
        this.successDialog = true;
      } catch (e) {
        this.showErrorDialog(i18n.t('LOGIN_PAGE_SETTING.SAVE_ERROR'));
      } finally {
        this.saving = false;
      }
    },
    // ── Dialog ────────────────────────────────────
    showErrorDialog(msg) {
      this.errorDialog = true;
      this.errorMessage = msg;
    },
    onEmitSuccessDialog() {
      this.successDialog = false;
    },
    onEmitErrorDialog() {
      this.errorDialog = false;
    },
  },
};
</script>

<style scoped>
/* ── 欄位包裹器 ── */
.lps-field {
  margin-bottom: 20px;
}

.lps-label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #444;
  margin-bottom: 6px;
}
.lps-label-16 {
  display: block;
  font-size: 16px;
  font-weight: 500;
  color: #444;
  margin-bottom: 6px;
}

.lps-hint {
  display: block;
  font-size: 12px;
  color: #666;
  margin-top: 4px;
}

/* ── 圖片上傳框 ── */
.lps-img-box {
  position: relative;
  border: 2px solid #D9D9D9;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  background-color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
}

.lps-img-box--logo {
  width: 70%;
  height: 80px;
  padding: 4px;
}

.lps-img-box--bg {
  width: 90%;
  aspect-ratio: 16 / 10;
  padding: 4px;
}

.lps-img-preview--contain {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.lps-img-preview--cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.lps-img-box__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.lps-img-box__overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.35);
  opacity: 0;
  transition: opacity 0.2s ease;
  border-radius: inherit;
  pointer-events: none;
}

.lps-img-box:hover .lps-img-box__overlay {
  opacity: 1;
}

.lps-img-box__delete {
  position: absolute !important;
  top: 6px !important;
  right: 6px !important;
  z-index: 2;
  background: transparent !important;
  pointer-events: all;
}

/* ── 顏色選擇器 ── */
.lps-color-swatch {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
  height: 36px;
  min-width: 140px;
}

.lps-color-swatch__block {
  /* width: 100%; */
  width: 24px;
  height: 24px;
  border-radius: 4px;
  flex-shrink: 0;
  border: 1px solid #666;
}

.lps-color-swatch__hex {
  font-size: 14px;
  color: #444;
  font-family: monospace;
}

/* ── 登入按鈕區塊標題 ── */
.lps-section-header {
  font-weight: 500;
  font-size: 14px;
  color: #444;
  padding-bottom: 8px;
  margin-top: 40px;
}

/* ── 確認按鈕 ── */
.lps-confirm-btn {
  background-color: #14C6DE !important;
  color: #FFFFFF !important;
  border-radius: 6px !important;
  height: 40px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
}

.login-setting-input::v-deep .v-text-field__slot input,
.login-setting-input::v-deep .v-text-field__slot textarea {
  padding-left: 10px;
}

/* 隱藏 scrollbar，但保留捲動功能 */
.login-setting-input.hide-arrow::v-deep .v-text-field__slot textarea {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE / Edge legacy */
}
.login-setting-input.hide-arrow::v-deep .v-text-field__slot textarea::-webkit-scrollbar {
  display: none; /* Chrome / Safari / Edge */
}


</style>
